// extracted by mini-css-extract-plugin
export var center = "_1f-2";
export var clickableRow = "_1f-5";
export var expandedRow = "_1f-7";
export var hoverable = "_1f-4";
export var left = "_1f-1";
export var right = "_1f-3";
export var row = "_1f-0";
export var selectedRow = "_1f-6";
export var summaryRow = "_1f-8";